import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dvir } from 'src/app/models/dvir';
import { PagedResponse } from 'src/app/models/pagedResponse';
import { ApiDataService } from 'src/app/shared/services/api.data.service';

@Injectable({
    providedIn: 'root'
  })
  export class DvirService {
    selectedDvir: Dvir;
    constructor(private api: ApiDataService) {
    }

    getDvirByVin(
        vin: string, 
        offset: number, 
        limit: number, 
        jsonFilter: string, 
        jsonSort: string,
        defectsOnly: boolean = true)
        : Observable<PagedResponse>
    {
        const url = this.api.buildGetUrlWithAdditionalParameters(
            `dvir/vin/${vin}`,
            { defectsOnly: defectsOnly },
            jsonFilter, 
            jsonSort, 
            offset, 
            limit);
        return this.api.get(url);
    }

    getDvirById(
        id: string)
        : Observable<Dvir>
    {
        const url = this.api.buildUrl(`dvir/${id}`);
        return this.api.get(url);
    }
  }